/**
 * The initials half of a chat's mark. `ChatAvatar` draws the photo instead
 * when messaging-api resolved an `avatarUrl` for the chat (ISSUE-1355): the
 * other fan's photo for a private chat, the chat's own for a stand-alone
 * chat. A pool chat, or any miss, keeps these initials.
 */

/**
 * Splits on whitespace, drops empty segments, takes the first letter of the
 * first two remaining segments, uppercased. A chat title is a name or a
 * pool name, not an email local-part, so this splits on whitespace only,
 * not on "."/"-"/"_" the way an email-derived initials helper would.
 */
export function initialsFromTitle(title: string): string {
  const segments = title.split(/\s+/).filter((segment) => segment.length > 0);
  if (segments.length === 0) return "?";
  return segments
    .slice(0, 2)
    .map((segment) => segment.charAt(0).toUpperCase())
    .join("");
}

/** `99` and under render as-is; anything higher caps at `99+`. */
export function formatUnreadCount(count: number): string {
  return count > 99 ? "99+" : String(count);
}
